module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am4_m.afd57eed0c763f441cf9627791f10488.png";